import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import { AttachClientToPartner } from './types'
import { $params } from 'src/features/router'
import { Error } from 'src/pages/gateway/edit/types'
import { getPartnerByClientId } from 'src/pages/clients/details/model'

export const attachClientToPartnerProfileMounted = createEvent()
export const setAttachClientToPartnerProfile =
  createEvent<AttachClientToPartner>()
export const submitEditPartner = createEvent<AttachClientToPartner>()

export const $attachClientToPartnerProfile = restore(
  setAttachClientToPartnerProfile,
  {
    partnerUserId: '',
    clientUserId: '',
  },
)

export const setAttachClientToPartnerError = createEvent<Error>()

export const $errorAttachClientToPartner = restore(
  setAttachClientToPartnerError,
  {
    message: '',
    code: 0,
  },
)

export const getPartner = fx<void, AttachClientToPartner>({
  method: 'GET',
  url: '/partner/',
})

export const updatePartner = fx<AttachClientToPartner, AttachClientToPartner>({
  method: 'POST',
  url: '/partner/',
})

sample({
  clock: submitEditPartner,
  source: $params,
  fn: (params, partner) => {
    let id
    if (params) {
      id = params.partnerID
    }
    return {
      url: `/partner/attach`,
      body: { ...partner },
    }
  },
  target: updatePartner,
})

// update profile model

sample({
  clock: getPartner.doneData,
  fn: (doneData) => doneData.body,
  target: setAttachClientToPartnerProfile,
})

sample({
  clock: updatePartner.doneData,
  fn: (doneData) => doneData.body,
  target: setAttachClientToPartnerProfile,
})

sample({
  clock: updatePartner.doneData,
  fn: (data) => {
    return {
      url: `/client/${data.body.clientUserId}/partner`,
    }
  },
  target: getPartnerByClientId,
})

sample({
  clock: updatePartner.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setAttachClientToPartnerError],
})
